document.addEventListener("DOMContentLoaded", () => {
  function copyToClip2(content) {
    var aux = document.createElement("input");
    aux.setAttribute("value", content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
  }

  var $BtnText = $('.sale-code-text')

  $(".sale-code-btn").click(function () {
    let text = $(".sale-code").text();
    copyToClip2(text);
    $BtnText.text('✓')
    setTimeout(function() {
        $BtnText.text('COPY')
    }, 3000)
  });

});
